(() => {
  'use strict';

  if (window.__msMotionV1Lifecycle) return;
  window.__msMotionV1Lifecycle = true;

  const fadeSelectors = [
    '[data-ms-motion="fade"]',
    '.ms-home-main .home-content-eyebrow',
    '.ms-home-main .home-unified-heading',
    '.ms-home-main .ms-home-company .content-split__media',
    '.ms-home-main .ms-reference__media',
    '.ms-home-main .ms-home-enquiry .compact-enquiry__intro',
    '.ms-home-main .ms-home-exhibitions .section-heading',
    '.ms-series__header',
    '.ms-certifications__heading',
    '.ms-factory-content .content-split__media',
    '.ms-factory-content .content-split__content'
  ];

  const staggerSelectors = [
    '[data-ms-motion="stagger"]',
    '.ms-home-main .mts-helmet-type',
    '.ms-home-main .ms-product-benefits__card',
    '.ms-home-main .ms-product-customization__card',
    '.ms-home-main .feature-card',
    '.ms-home-main .ms-oem-reference__step',
    '.ms-series__grid > .ms-product-card',
    '.ms-certifications__cards > .ms-certifications__card'
  ];

  const allSelectors = [...fadeSelectors, ...staggerSelectors].join(', ');
  const cardSelectors = staggerSelectors.join(', ');
  const reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)');
  const observed = new Set();

  if (!('IntersectionObserver' in window)) return;

  const reveal = (element) => {
    element.classList.add('ms-motion-visible');
    observer.unobserve(element);
    observed.delete(element);
  };

  const observer = new IntersectionObserver((entries) => {
    for (const entry of entries) {
      if (entry.isIntersecting) reveal(entry.target);
    }
  }, {
    root: null,
    rootMargin: '0px 0px -9% 0px',
    threshold: 0.01
  });

  const register = (root = document) => {
    if (reducedMotion.matches) return;
    const targets = [...root.querySelectorAll(allSelectors)];
    if (root.nodeType === 1 && root.matches(allSelectors)) targets.unshift(root);

    for (const element of targets) {
      if (element.dataset.msMotionRegistered === 'true') continue;
      element.dataset.msMotionRegistered = 'true';

      if (element.closest('.home-hero')) continue;

      const rect = element.getBoundingClientRect();
      if (!rect.width || !rect.height || rect.top < 0) continue;

      const isAlreadyVisible =
        rect.top < window.innerHeight * .88 &&
        rect.left < window.innerWidth &&
        rect.right > 0;

      if (isAlreadyVisible) continue;

      if (element.matches(cardSelectors)) {
        const index = [...element.parentElement.children].filter(child => child.matches(cardSelectors)).indexOf(element);
        if (!element.style.getPropertyValue('--ms-motion-delay')) element.style.setProperty('--ms-motion-delay', `${Math.min(index % 4, 3) * 80}ms`);
        if (!element.style.getPropertyValue('--ms-motion-distance')) element.style.setProperty('--ms-motion-distance', 'var(--ms-distance-stagger, 20px)');
        if (!element.style.getPropertyValue('--ms-motion-duration')) element.style.setProperty('--ms-motion-duration', '600ms');
      }

      element.classList.add('ms-motion-pending');
      observed.add(element);
      observer.observe(element);
    }
  };

  const start = () => {
    register();

    document.addEventListener('shopify:section:load', (event) => {
      register(event.target);
    });

    document.addEventListener('shopify:section:unload', (event) => {
      for (const element of [...observed]) {
        if (event.target.contains(element)) reveal(element);
      }
    });

    document.addEventListener('focusin', (event) => {
      const element = event.target.closest?.('.ms-motion-pending:not(.ms-motion-visible)');
      if (element) reveal(element);
    });

    reducedMotion.addEventListener?.('change', (event) => {
      if (event.matches) {
        for (const element of [...observed]) reveal(element);
      } else {
        register();
      }
    });
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', start, { once: true });
  } else {
    start();
  }
})();

